module.exports = __webpack_public_path__ + "img/couturme-logo.efcdfe07.png";